var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table-paging-filtering',{attrs:{"headers":_vm.headers,"get-items-func":_vm.getItems,"item-row-background-func":_vm.itemRowBackgroundFunc,"show-expand":false,"dense":false,"sync":false,"uniqueID":"members-list"},scopedSlots:_vm._u([{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('v-chip',[_vm._v(" "+_vm._s(_vm.getStatus(item.status))+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }